<template>
  <div>
    <ASearchForm
      :modelName="'Cart'"
      :create="false"
      :dropdownProps="[{type:'text', name: 'Cart ID Contains', payloadKey: 'cartName'}, {model:'contracts', name: 'Contract', payloadKey: 'contractId'},{type:'text',name: 'Car #', payloadKey: 'car'}, {model:'states', name: 'Status', payloadKey: 'stateId'},{model:'stations', name: 'Station', payloadKey: 'stationId'}, {model:'locations', name: 'Location', payloadKey: 'locationId'},{type:'text',name: 'Missing Part', payloadKey: 'partId[]'}]"
      @change="search"
      ref="ASearchForm"
      class="mb-5"
    ></ASearchForm>
    <CartsLog ref="refCartsLog" :apiParams="apiParams" :exportable="true"></CartsLog>
  </div>
</template>

<script>
import CartsLogMixin from "../../mixins/CartsLog";
import CRUDFuncsMixin from "../../mixins/CRUDFuncs";
import ASearchForm from "../../components/ASearchForm";
import CartsLog from "../../components/CartsLog";
import ADataTable from "../../components/ADataTable";
import logApi from "../../api/log";

export default {
  name: "ScanLog",
  mixins: [CartsLogMixin, CRUDFuncsMixin],
  components: {
    ASearchForm,
    ADataTable,
    CartsLogMixin,
    CartsLog
  },
  data() {
    return {
      model: "cartscanlog",
      apiParams: {}
    };
  },
  methods: {
    search(payload) {
      this.apiParams = payload;
    }
  }
};
</script>



